import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import Link from '@nerdwallet/react-link';
import Type from '@nerdwallet/react-typography';
import Button from '@nerdwallet/react-button';

export const ARTICLE_TYPE = {
  EXTERNAL: 'EXTERNAL',
  PAGE_PREVIEW: 'PAGE_PREVIEW',
  INTERNAL: 'INTERNAL',
};

class PressArticle extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderSourceIcon(mediaSite) {
    const { type } = this.props.article;

    if (type !== ARTICLE_TYPE.EXTERNAL) {
      return null;
    }

    const style = {};

    if (mediaSite && mediaSite.nw_logo) {
      style.backgroundImage = `url(${mediaSite.nw_logo})`;
    }

    return <div className="press-article__icon" style={style} />;
  }

  renderPreviewLink() {
    const { previewLinkText, type, link } = this.props.article;

    if (type !== ARTICLE_TYPE.PAGE_PREVIEW) {
      return (
        <Link href={link} target="_blank" rel="noopener noreferrer">
          <Type size="2">Read more</Type>
        </Link>
      );
    }

    return (
      <div className="press-article__btn">
        <Button primary href={link}>
          {previewLinkText}
        </Button>
      </div>
    );
  }

  renderByline() {
    const { article } = this.props;
    const { type } = article;
    const rawAuthors = article.author;

    if (type !== ARTICLE_TYPE.INTERNAL) {
      return null;
    }

    const authors = _.map(rawAuthors, (authorDetails, i) => {
      let { name, link } = authorDetails;
      name = name || 'NerdWallet';
      link = link || '';

      return (
        <a href={link} key={i}>
          {name}
        </a>
      );
    });

    const byline = [];

    _.forEach(authors, (author, i) => {
      byline.push(author);

      if (i < authors.length - 2) {
        byline.push(', ');
      } else if (i === authors.length - 2) {
        byline.push(' and ');
      }
    });

    const defaultAvatar =
      'https://secure.gravatar.com/avatar/b17f02f43fecdf671277bc182598db9b?s=96&amp;d=mm&amp;r=g';
    const avatar =
      rawAuthors.length > 2
        ? defaultAvatar
        : _.get(rawAuthors, '[0].avatar_urls.[96]', defaultAvatar);

    return (
      <div className="press-article__byline">
        <a
          className="press-article__link"
          href={_.get(rawAuthors, '0.link', '')}
        >
          <img
            alt=""
            src={avatar}
            className="press-article__circle"
            height="96"
            width="96"
          />
        </a>
        <span className="press-article__author">by {byline}</span>
      </div>
    );
  }

  render() {
    const {
      title,
      imageSource,
      link,
      className,
      excerpt,
      mediaSite,
      type,
    } = this.props.article;
    const linkProps =
      type !== ARTICLE_TYPE.EXTERNAL
        ? {}
        : { target: '_blank', rel: 'noopener noreferrer' };
    const imageStyle = {};
    const getTitleHTML = () => ({ __html: title });
    const getExcerptHTML = () => ({ __html: excerpt });

    if (imageSource) {
      imageStyle.backgroundImage = `url(${imageSource})`;
    }

    return (
      <div className={classnames('press-article', className)}>
        <a href={link} {...linkProps}>
          <div className="press-article__img" style={imageStyle}>
            <div className="press-article__overlay" />
          </div>
        </a>
        <div className="press-article__content">
          <div className="press-article__vcenter">
            {this.renderSourceIcon(mediaSite)}
            <Link href={link} color="neutral-darkest" {...linkProps}>
              <Type
                size="4"
                chronicle
                color="neutral-darkest"
                className={classnames(['press-article__title'])}
                dangerouslySetInnerHTML={getTitleHTML()}
              />
            </Link>
            {this.renderByline()}
            <div
              className="press-article__excerpt"
              // eslint-disable-next-line react/no-danger -- directive added automatically by Shepherd migration
              dangerouslySetInnerHTML={getExcerptHTML()}
            />
            {this.renderPreviewLink()}
          </div>
        </div>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PressArticle.propTypes = {
  article: PropTypes.object.isRequired,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PressArticle.displayName = 'PressArticle';

export default PressArticle;
